import React, { useState, useEffect, useContext } from "react";
import toastr from "toastr";
import PostOrder from "../PostOrder";
import PayoutChart from "./PayoutChart";
import { calculatePayout } from "./calculatePayout";
import { GlobalContext } from "../header/GlobalContext";
import H2hModal from "../modals/H2hModal.js";
import SelectedAthleteBox from "./SelectedAthleteBox";

const Sidebar = (props) => {
  const loggedIn = document.body.classList.contains('logged-in');
  const [showSidebar, setShowSidebar] = useState(false);
  const [wagerMsg, setWagerMsg] = useState("");
  const [maxWager, setMaxWager] = useState(100000);
  const largerBalance = props.balance > parseFloat(document.getElementById("promo-balance").value) ? props.balance : parseFloat(document.getElementById("promo-balance").value);
  const [wagerInput, setWagerInput] = useState(!loggedIn ? 5 : Math.min(largerBalance, 5));
  const [payout, setPayout] = useState(0);
  const [h2hPayout, setH2HPayout] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showH2HModal, setShowH2HModal] = useState(false);
  const { isH2H, setIsH2H, h2hWager, h2hCount, multiplier, setMultiplier, multiplierType, setMultiplierType, protectedMultipliers, setProtectedMultipliers } = useContext(GlobalContext);
  const promoBalance = parseFloat(document.getElementById("promo-balance").value);
  const verified = document.getElementById('verified').value == 1;
  const h2hOnly = document.getElementById('h2h-only').value == 1;

  const [opponentOid, setOpponentOid] = useState(0);
  const [showMultiplierTypes, setShowMultiplierTypes] = useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false); // New state for button disabling

  const [maxPayout, setMaxPayout] = useState(100000);
  const first = $("#first").val() == '1';
  const shrk = $("#shrk").val() == '1';

  useEffect(() => {

    const cmsMaxPayout = document.getElementById('max-payout').value;
    const startingMaxPayout = props.balance > 0 ? cmsMaxPayout : 10000;
    setMaxPayout(startingMaxPayout);

    if (h2hWager && h2hCount) {
      setWagerInput(h2hWager);
      calculateH2HPayout(h2hWager);
      setIsH2H(true);
      const urlParams = new URLSearchParams(window.location.search);
      const h2hParam = urlParams.get('h2h');
      if (h2hParam) {
        setOpponentOid(h2hParam);
      }
    }
  });

  useEffect(() => {
    if (isH2H) {
      calculateH2HPayout(wagerInput);
    }
    if (isH2H && !h2hWager && !h2hCount) {
      setMaxWager(100000);
    }
  }, [isH2H]);

  useEffect(() => {
    if (props.selected.length > 0 && !showSidebar) {
      setShowSidebar(true);
    }
    if (h2hOnly) {
      setIsH2H(true);
    }

    // Check if selected have any easy or hard
    const easy = props.selected.find((x) => x.easy);
    const hard = props.selected.find((x) => x.hard);
    const promo = props.selected.find((x) => x.promo);

    if (props.selected.length < 3 || easy || hard || promo) {
      setMultiplierType(null);
      setShowMultiplierTypes(false);
    } else {
      setShowMultiplierTypes(true);
      if (!multiplierType) {
        setMultiplierType("power");
      }
    }

  }, [props.selected, showSidebar]);

  useEffect(() => {

    const wagerInputBox = document.getElementsByClassName("entry-input")[0];
    if (props.selected.length > 1 && wagerInputBox && !h2hWager) {
      wagerInputBox.removeAttribute("disabled", "");
    } else if (wagerInputBox) {
      wagerInputBox.setAttribute("disabled", "");
    }

    const newPayout = calculatePayout(props.selected, wagerInput, setMultiplier, setProtectedMultipliers, multiplierType);
    setPayout(newPayout);
    let largerBalance = props.balance > promoBalance ? props.balance : promoBalance;

    if (!loggedIn || wagerInput > largerBalance) {
      return;
    }

    // If promo in line-up, set max wager to 5
    if (props.selected.find((x) => x.promo) && wagerInput > 5) {
      setWagerInput(5);
      setPayout(calculatePayout(props.selected, 5, setMultiplier, setProtectedMultipliers, multiplierType));
      toastr["warning"](
        "Promo athletes have a max wager of $5.",
        "Notice"
      );
    }

    const twoPickMax = $('#two-pick').val();
    const threePickMax = $('#three-pick').val();
    const fourPickMax = $('#four-pick').val();

    if (props.selected.length === 2 && wagerInput > twoPickMax) {
      setWagerInput(twoPickMax);
      setPayout(calculatePayout(props.selected, twoPickMax, setMultiplier, setProtectedMultipliers, multiplierType));
      toastr["warning"](
        "Add more athletes to increase wager.",
        "Notice"
      );
      return;
    }

    if (props.selected.length === 3 && wagerInput > threePickMax) {
      setWagerInput(threePickMax);
      setPayout(calculatePayout(props.selected, threePickMax, setMultiplier, setProtectedMultipliers, multiplierType));
      toastr["warning"](
        "Add more athletes to increase wager.",
        "Notice"
      );
      return;
    }

    if (props.selected.length === 4 && wagerInput > fourPickMax) {
      setWagerInput(fourPickMax);
      setPayout(calculatePayout(props.selected, fourPickMax, setMultiplier, setProtectedMultipliers, multiplierType));
      toastr["warning"](
        "Add more athletes to increase wager.",
        "Notice"
      );
      return;
    }

    if (newPayout > maxPayout && !isH2H) {
      setIsH2H(true);
      if (!showH2HModal) {
        setShowH2HModal(true);
        $('#h2h-modal').modal('show');
      }
    }

    if (newPayout <= maxPayout && isH2H && !h2hOnly) {
      setIsH2H(false);
    }

    if (isH2H) {
      calculateH2HPayout(wagerInput);
    }

  }, [props.selected, loggedIn, wagerInput, isH2H, multiplierType]);


  const getPowerMultiplier = () => {
    const athleteCount = props.selected.length;
    // switch on athleteCount
    switch (athleteCount) {
      case 2:
        return 3;
      case 3:
        return 5;
      case 4:
        return 10;
      case 5:
        return 15;
      case 6:
        return 20;
      default:
        return 0;
    }
  }

  const calculateH2HPayout = (wager) => {
    const h2hPayout = Math.floor((wager * 1.8).toFixed(2));
    setH2HPayout(h2hPayout);
  };

  const moneyFormat = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  const handleEntrySubmit = async (props) => {
    if (isSubmitDisabled) return; // Prevent double submission
    setIsSubmitDisabled(true); // Disable the button on first click
    setLoading(true); // Show spinner, hide button

    if (parseInt(payout) > maxPayout && props.selected.length < 4) {
      toastr["error"](
        "H2H mode requires 4 or more athletes.",
        "Error"
      );
      setIsSubmitDisabled(false);
      setLoading(false); // Restore button, hide spinner
      return;
    }

    // Check if all easy & payout over $20
    let allEasy = props.selected.every((x) => x.easy || x.promo);
    if (allEasy && parseInt(payout) > 10) {
      toastr["error"](
        "Strictly easy pick entries are capped at $10 payout.",
        "Error"
      );
      setIsSubmitDisabled(false);
      setLoading(false);
      return;
    }

    let easyCount = props.selected.filter((x) => x.easy).length;
    let majorityEasy = easyCount > props.selected.length / 2;
    if (majorityEasy && parseInt(payout) > 15) {
      toastr["error"](
        "Majority easy pick entries are capped at $15 payout.",
        "Error"
      );
      setIsSubmitDisabled(false);
      setLoading(false);
      return;
    }

    if (parseInt(payout) > maxPayout && !isH2H) {
      toastr["error"](
        `Non-Free entries are currently only active for payouts under $${maxPayout}.`,
        "Error"
      );
      setIsSubmitDisabled(false);
      setLoading(false);
      return;
    }

    if (parseInt(payout) == 0 && !isH2H) {
      toastr["error"](
        "Free entries reserved for H2H States.",
        "Error"
      );
      setIsSubmitDisabled(false);
      setLoading(false);
      return;
    }

    if (!verified && wagerInput > 0) {
      toastr["error"](
        "Please verify your account before placing an entry",
        "Notice"
      );
      setIsSubmitDisabled(false);
      setLoading(false);
      return;
    }

    // Check all selected athletes to see if same name exists
    let names = props.selected.map((x) => x.name);
    let hasDuplicates = names.some(
      (val, i) => names.indexOf(val) !== i
    );
    if (hasDuplicates) {
      toastr["error"](
        "Each athlete can only be selected once. Please remove one to continue.",
        "Notice"
      );
      setIsSubmitDisabled(false);
      setLoading(false);
      return;
    }

    if (wagerInput > maxWager) {
      setIsH2H(true);
      // toastr["warning"](
      //   `Maximum wager is $${maxWager} for ${props.selected.length} athletes currently. Add more athletes or select H2H to increase wager.`,
      //   "Notice"
      // );
      // return;
    }

    // Make sure no athletes start time has passed
    // let currentTime = new Date();
    // Give 5 min buffer
    // currentTime.setMinutes(currentTime.getMinutes() + 5);
    // let pastTime = props.selected.find(
    //   (x) => parseDateTime(x.start_time_obj) < currentTime
    // );

    // if (pastTime) {
    //   toastr["error"](
    //     "One or more athletes have already started. Remove athlete(s) to continue.",
    //     "Notice"
    //   );
    //   return;
    // }

    // If ufc athlete in line-up, verify all athletes are not opponents
    let ufcAthlete = props.selected.find((x) => x.league === "ufc");
    if (ufcAthlete) {
      let opponent = props.selected.find(
        (x) => x.name === ufcAthlete.opponent_short && x !== ufcAthlete
      );
      if (opponent) {
        toastr["error"](
          "Line-up cannot have opponents facing each other. Remove one athlete from the same fight",
          "Notice"
        );
        setIsSubmitDisabled(false); // Re-enable the button after operation
        setLoading(false);
        return;
      }
    }

    // Verify line-up is not all the same team
    let firstTeam = props.selected[0].team_short;
    let allSameTeam = props.selected.every(
      (x) =>
        x.team_short && x.team_short === firstTeam && x.league !== "ufc"
    );
    if (allSameTeam) {
      toastr["error"](
        "Line-up cannot have only athletes from the same team. Remove one athlete with matching team",
        "Notice"
      );
      setIsSubmitDisabled(false); // Re-enable the button after operation
      setLoading(false);
      return;
    }

    // Only allow promo in lineup IF more than 2
    let promoAthletes = props.selected.filter((x) => x.promo);
    if (promoAthletes.length > 0 && props.selected.length < 3) {
      toastr["warning"](
        "Add one more athlete to get Promo offer",
        "Notice"
      );
      setIsSubmitDisabled(false); // Re-enable the button after operation
      setLoading(false);
      return;
    }

    // Make sure not more than one promo athlete in line-up
    if (promoAthletes.length > 1) {
      toastr["error"](
        "Only one promo athlete can be selected per entry",
        "Notice"
      );
      setIsSubmitDisabled(false); // Re-enable the button after operation
      setLoading(false);
      return;
    }

    try {
      let e = {};
      e.currentTarget = {};
      e.currentTarget.dataset = {};
      e.currentTarget.dataset.prop = "loading";
      e.currentTarget.value = true;
      props.onClick(e);

      let entryData = {};
      entryData.selected = props.selected;
      entryData.wager = wagerInput;
      entryData.payout = payout;
      entryData.isH2H = isH2H;
      entryData.h2hPayout = h2hPayout;
      entryData.opponentOid = opponentOid;
      entryData.multiplierType = multiplierType;

      // Clear selected from localStorage
      localStorage.removeItem("selected");

      // Now check every value for manipulation
      const response = await PostOrder(entryData);
      let urlResponse = response.match(/(http|https):\/\/[^ "]+/g);
      if (urlResponse) {
        window.location.href = response;
      } else {
        toastr["error"](response, "Error");
        // after 5 sec. reload the page
        setTimeout(function () {
          location.reload();
        }, 3000);
      }
    } catch (error) {
      console.error("Error submitting entry:", error);
      toastr["error"]("An error occurred. Please try again.", "Error");
      setIsSubmitDisabled(false);
      setLoading(false);
    }
    // Do not reset loading/isSubmitDisabled here, as navigation or reload will occur
  };


  const handleInputChange = (input) => {
    let inputValue = Math.floor(input); // Ensure only whole numbers
    let largerBalance = props.balance > promoBalance ? props.balance : promoBalance;
    let zeroBalance = props.balance == 0 && promoBalance == 0;


    if (inputValue > largerBalance && loggedIn && !zeroBalance) {
      setWagerInput(largerBalance);
      setWagerMsg("Refill balance for $" + inputValue + " wager.");
      return;
    }

    inputValue = inputValue > maxWager ? maxWager : inputValue;
    if (inputValue > maxWager && !isH2H) {
      setIsH2H(true);
    } else {
      setWagerMsg("");
    }
    setWagerInput(inputValue);
    setPayout(calculatePayout(props.selected, inputValue, setMultiplier, setProtectedMultipliers, multiplierType));
    calculateH2HPayout(inputValue);
  };

  if (!showSidebar) {
    return (
      <>
        <label htmlFor="toggle-sidebar-button" className="sr-only">Expand Sidebar</label>
        <div
          id="toggle-sidebar-button"
          className="align-top toggle-sidebar"
          onClick={() => setShowSidebar(true)}
        >
          <span>Expand</span>
          <i className="fa fa-expand" aria-hidden="true"></i>
        </div>
      </>
    );
  } else {
    return (
      <div className="d-flex flex-wrap justify-content-end m-2 flex-fill">
        <div className="selected-container">
          <div className="select-title mt-2 mb-3">
            Select 2 or More Athletes
          </div>

          <SelectedAthleteBox selected={props.selected} onClick={props.onClick} />

          {props.selected.length < 2 && (
            <div>
              {props.selected.length == 0 && (
                <div className="select-holder mb-3 w-100">
                  Add Athlete One
                </div>
              )}
              <div className="select-holder mb-3 w-100">
                Add Athlete Two
              </div>
            </div>
          )}


          { props.selected.length > 2 && !isH2H && showMultiplierTypes && (
            <div className="row justify-content-center mt-3 align-items-start mt-2">
              <div className="col-6 pr-1">
                <button
                  className={`btn entry-type w-100 d-flex flex-column align-items-center ${multiplierType === "protected" ? "selected" : ""}`}
                  onClick={() => setMultiplierType("protected")}
                >
                  <div className="lead"><i className="fa-solid fa-shield"></i></div>
                  <b>Protected</b>
                  <div className="desc">{props.selected.length} hits: <b>{protectedMultipliers[0]}X</b></div>
                  <div className="desc">{props.selected.length - 1} hits: <b>{protectedMultipliers[1]}X</b></div>
                  {protectedMultipliers[2] && (
                    <div className="desc">{props.selected.length - 2} hits: <b>{protectedMultipliers[2]}X</b></div>
                  )}
                </button>
              </div>
              <div className="col-6 pl-1">
                <button
                  className={`btn entry-type w-100 d-flex flex-column align-items-center ${multiplierType === "power" ? "selected" : ""}`}
                  onClick={() => setMultiplierType("power")}
                >
                  <div className="lead"><i class="fa-solid fa-coins"></i></div>
                  <b>All In</b>
                  <div className="desc">Requires all Correct: <b>{getPowerMultiplier()}X</b></div>
                </button>
              </div>
            </div>
          )}

          <div className="row justify-content-center mt-3" id="balance-box">
            <div className="col-6">
              <small>Balance: ${props.balance}</small>
            </div>

            {promoBalance > 0 && (
              <div className="col-6">
                <small>Promo: ${promoBalance}</small>
              </div>
            )}

            <div className="col-12">
              <div className="entry-box">
                <label htmlFor="wager-input" className="sr-only">Wager Amount</label>
                $<input
                  id="wager-input"
                  onChange={(e) => handleInputChange(e.target.value)}
                  data-prop="wager"
                  type="number"
                  min="0"
                  max={maxWager}
                  pattern="\d*"
                  value={wagerInput}
                  className="entry-input"
                  placeholder="0"
                  disabled={true}
                  step="1"
                />
              </div>
            </div>
            <div className="col-12 mt-2">
              {wagerMsg && (
                <div className="card-txt stats">{wagerMsg}</div>
              )}

              <div className="winningsTxt">To Win</div>
              {parseInt(payout) <= maxPayout && isH2H && !h2hCount && !h2hOnly && <div className="winningsTxt">Single Player</div>}
              {parseInt(payout) <= maxPayout && !h2hCount && !h2hOnly && <div className="payoutAmt">{moneyFormat.format(payout)}</div>}
              { isH2H && (
                <div>
                  <div className="winningsTxt">H2H Payout</div>
                  <div className="payoutAmt mb-3">{moneyFormat.format(h2hPayout)}</div>
                </div>
              )}
            </div>
          </div>

          {!loggedIn && (
            <button
              type="submit"
              name="add-to-cart"
              value="logged-out"
              data-toggle="modal"
              data-target="#register-modal"
              className="single_add_to_cart_button button alt mt-2"
            >
              Submit Line-up
            </button>
          )}

          {loggedIn && parseFloat(wagerInput) > parseFloat(props.balance) && parseFloat(wagerInput) > parseFloat(promoBalance) && (
            <button
              type="submit"
              name="add-to-cart"
              value="missing-balance"
              data-toggle="modal"
              data-target="#add-balance"
              className="single_add_to_cart_button button alt"
            >
              Submit Line-up
            </button>
          )}

          {loading && (
            <div className="spinner-border" role="status" />
          )}

          {!loading && loggedIn &&
          (parseFloat(wagerInput) <= parseFloat(props.balance) || parseFloat(wagerInput) <= parseFloat(promoBalance)) && (
            <button
              onClick={() => handleEntrySubmit(props)}
              name="add-to-cart"
              value="26684"
              className="single_add_to_cart_button button alt"
              disabled={isSubmitDisabled} // Disable button when submitting
            >
              Submit Line-up
            </button>
          )}

          <PayoutChart props={props} />
          <H2hModal payout={payout} />
        </div>
      </div>
    );
  }
};

export default Sidebar;
